import * as React from 'react';
import {
    Button,
    ButtonSize,
    ButtonVariant,
    H5Emphasized,
    SelectSingle,
    YStack,
} from 'smoothie';

interface CardLocationProps {
    lostOrStolen: boolean | null;
    onSelect: (lostOrStolen: boolean) => void;
    onPress: () => void;
}

const CardLocation = ({
    lostOrStolen,
    onSelect,
    onPress,
}: CardLocationProps) => {
    return (
        <YStack flex={1} justifyContent="space-between">
            <YStack gap={6}>
                <H5Emphasized textAlign="left">
                    Do you still have your physical card or know where it is?
                </H5Emphasized>
                <YStack width="100%" marginTop={24}>
                    <SelectSingle
                        options={[{ title: 'Yes' }, { title: 'No' }]}
                        selectedIndex={
                            lostOrStolen === false
                                ? 0
                                : lostOrStolen === true
                                  ? 1
                                  : null
                        }
                        onSelect={(index) => {
                            onSelect(index === 1);
                        }}
                    />
                </YStack>
            </YStack>
            <Button
                variant={ButtonVariant.PRIMARY}
                onPress={onPress}
                size={ButtonSize.LARGE}
                text="Next"
                disabled={lostOrStolen === null}
            />
        </YStack>
    );
};

export default CardLocation;
